export default __webpack_public_path__ + "static/media/courtney-2.38f2478b.jpg";